import React from 'react';
import { S } from './CompanyStatistics.styles';
import { useTable } from 'react-table';
import { useCompanyStatisticsTableData } from './useCompanyStatisticsTableData';
import { useGetCompanyStatistics } from '../../../../../../traits/api/controls/useGetCompanyStatistics';

export const CompanyStatistics = ({
  controlId,
}: {
  controlId: string;
  inspectionId: string;
}) => {
  const { data: controlStatistics } = useGetCompanyStatistics(controlId);
  const data = useCompanyStatisticsTableData(controlStatistics);
  const table = useTable(data);

  if (!controlStatistics || controlStatistics.length === 0) return <></>;
  if (data.data.length === 0) {
    return <></>;
  }

  return (
    <S.TWrapper>
      <S.Table {...table.getTableProps()}>
        <S.THead>
          {table.headerGroups.map((headerGroup) => (
            <S.THeadRow
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.getHeaderGroupProps().key}
            >
              {headerGroup.headers.map((column) => {
                return (
                  <S.THeadCell
                    {...column.getHeaderProps()}
                    key={column.getHeaderProps().key}
                  >
                    <S.B3 $color="black">{column.render('Header')}</S.B3>
                  </S.THeadCell>
                );
              })}
            </S.THeadRow>
          ))}
        </S.THead>

        <S.TBody {...table.getTableBodyProps()}>
          {table.rows.map((row) => {
            table.prepareRow(row);

            return (
              <S.TBodyRow {...row.getRowProps()} key={row.getRowProps().key}>
                {row.cells.map((cell) => {
                  return (
                    <S.TBodyCell
                      {...cell.getCellProps()}
                      key={cell.getCellProps().key}
                    >
                      {cell.column.id === 'statisticsDescription' ? (
                        <S.Flex>{cell.render('Cell')}</S.Flex>
                      ) : (
                        cell.render('Cell')
                      )}
                    </S.TBodyCell>
                  );
                })}
              </S.TBodyRow>
            );
          })}
        </S.TBody>
      </S.Table>
    </S.TWrapper>
  );
};
